import { LitElement, html, svg } from 'lit';

export class IconBurger32 extends LitElement {
  render() { return html`<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32"><title>Tre horisontale streker</title><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M3 5h26M3 16h26M3 27h26"></path></svg>`; }
}
if (!customElements.get('f-icon-burger32', IconBurger32)) {
  customElements.define('f-icon-burger32', IconBurger32);
}